if (!customElements.get('mewant-mobile-collapse')) {
  let sequence = 0;
  customElements.define('mewant-mobile-collapse', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.content = this.querySelector('.mw-collapse-content');
      this.button = this.querySelector('.mw-collapse-toggle');
      this.content.id = `mw-collapse-${++sequence}`;
      this.button.setAttribute('aria-controls', this.content.id);
      this.media = matchMedia('(max-width:749px)');
      this.expanded = false;
      this.focusable = new Map();
      if (this.dataset.kind === 'description') this.closest('.product-block-list__item--description')?.classList.add('mw-mobile-description');
      const signal = this.controller.signal;
      this.button.addEventListener('click', () => { this.expanded = !this.expanded; this.update(); }, {signal});
      this.media.addEventListener('change', () => this.update(), {signal});
      this.content.addEventListener('load', () => this.update(), {capture:true, signal});
      this.observer = new ResizeObserver(() => {
        if (this.width !== this.content.clientWidth) { this.width = this.content.clientWidth; this.update(); }
      });
      this.observer.observe(this.content);
      document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
      this.update();
    }
    update() {
      this.removeAttribute('data-collapsed');
      this.focusable.forEach((value, el) => value === null ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', value));
      this.focusable.clear();
      const title = this.dataset.kind === 'title';
      const element = title ? this.content.querySelector('h1') : this.content;
      const style = getComputedStyle(element);
      const line = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
      const lines = Number(this.dataset.lines) || (title ? 2 : 3);
      let height = line * lines;
      const top = this.content.getBoundingClientRect().top;
      const overflow = this.content.scrollHeight > height + 1;
      if (!title && overflow) {
        this.content.querySelectorAll('img,video,iframe,button,a,table').forEach(el => {
          const rect = el.getBoundingClientRect();
          const start = rect.top - top;
          if (start < height && rect.bottom - top > height) height = Math.max(0, start);
        });
      }
      this.button.hidden = !this.media.matches || !overflow;
      const collapsed = this.media.matches && overflow && !this.expanded;
      this.style.setProperty('--mw-collapse-height', `${height}px`);
      this.style.setProperty('--mw-collapse-lines', lines);
      this.toggleAttribute('data-collapsed', collapsed);
      this.button.textContent = this.expanded ? this.dataset.less : this.dataset.more;
      this.button.setAttribute('aria-expanded', String(!collapsed));
      if (collapsed) this.content.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el => {
        if (el.getBoundingClientRect().bottom - top > height) {
          this.focusable.set(el, el.getAttribute('tabindex')); el.setAttribute('tabindex', '-1');
        }
      });
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.observer?.disconnect();
    }
  });
}
